import { handleActions } from 'redux-actions';
import * as ordersActions from '../actions/orders';

let ordersState = {
  allOrders: null,
  allOrdersStat: null,
  allDrivers: null,
  watchedStat: null,
  filterOrders: null,
  filterOrdersStat: null,
  ordersLoading: false,
  errorMessage: '',
};

export const orders = handleActions(
  {
    //Get All Orders
    [ordersActions.getAllOrders]: state => {
      return { ...state, ordersLoading: true };
    },
    [ordersActions.getAllOrdersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        orderTypes: payload.orderTypes,
        allOrders: payload.orders,
        allOrdersStat: payload.ordersStat,
        allDrivers: payload.drivers,
        watchedStat: payload.watchedStat,
        ordersLoading: false,
      };
    },
    [ordersActions.getAllOrdersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        ordersLoading: false,
      };
    },
    //Get Filter Orders
    [ordersActions.getFilterOrders]: state => {
      return { ...state, ordersLoading: true };
    },
    [ordersActions.getFilterOrdersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        filterOrders: payload.orders,
        filterOrdersStat: payload.ordersStat,
        ordersLoading: false,
      };
    },
    [ordersActions.getFilterOrdersError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        ordersLoading: false,
      };
    },
    // watch/unwatch entity
    [ordersActions.watchOrder]: state => {
      return state;
    },
    [ordersActions.watchOrderSuccess]: (state, action) => {
      return {
        ...state,
        allOrders: action.payload.orders,
        watchedStat: action.payload.watchedStat,
      };
    },
    [ordersActions.unwatchOrder]: state => {
      return state;
    },
    [ordersActions.unwatchOrderSuccess]: (state, action) => {
      return {
        ...state,
        allOrders: action.payload.orders,
        watchedStat: action.payload.watchedStat,
      };
    },
  },
  ordersState
);
